define('formkit/view/form.object/common/base.form.object.top.view',['require','exports','module','uikit/uikit','../../../templates'],function(require, exports, module) {
  var UIKit     = require('uikit/uikit');
  var Templates = require('../../../templates');

  var BaseFormObjectTopView = UIKit.ItemView.extend({
    className: 'top',

    template: Templates.App['form.object.top'],

    options: {
      actions: [],
      form: null
    },

    triggers: {
      'click': {
        event: 'press',
        stopPropagation: true
      },
      'click .header' : {
        event: 'header:press',
        stopPropagation: false
      }
    },

    internalViewOptions: {
      indicatorView: function() {
        return {
          model: this.model,
          form: this.form
        }
      },
      actionsView: function () {
        return {
          model: this.model,
          form: this.form
        }
      }
    }
  });

  module.exports = BaseFormObjectTopView;
});

